import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Truncate from 'react-truncate'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import { paragraph1CommonStyles } from '../Typo'
import { P2 } from '../Typo'

const ReadMore = props => {
  const [expanded, toggleExpanded] = useState(false)
  const [truncated, toggleTruncated] = useState(false)
  const { children, more, less, lines, className, id, disabled, handleClick } = props

  const handleTruncate = _truncated => {
    if (truncated !== _truncated) {
      toggleTruncated(_truncated)
    }
  }

  const toggleLines = event => {
    event.preventDefault()
    toggleExpanded(expanded => {
      const newState = disabled ? expanded : !expanded
      handleClick(newState)
      return newState
    })
  }

  const innerRef = useRef(null)
  innerRef?.current?.onResize()

  return (
    <Div className={className} data-testid={id}>
      <ShortText>
        <Truncate
          ref={innerRef}
          lines={!expanded && lines}
          ellipsis={
            <>
              &nbsp;
              <ReadMoreText data-testid={`${id}-expand-link`} href="#" onClick={toggleLines}>
                {more}...
              </ReadMoreText>
            </>
          }
          onTruncate={handleTruncate}
        >
          <P2>{children}</P2>
        </Truncate>
      </ShortText>
      {!truncated && expanded && (
        <ReadLessText data-testid={`${id}-collapse-link`} href="#" onClick={toggleLines}>
          {less}
        </ReadLessText>
      )}
    </Div>
  )
}

const Div = styled.div`
  width: 100%;
`

const ReadMoreText = styled(P2)`
  padding-top: 6px;
  color: ${props => props.theme.palette.grey2};
  cursor: pointer;
`

const ReadLessText = styled(P2)`
  padding-top: 6px;
  color: ${props => props.theme.palette.burgundy1};
  color: ${props => props.theme.palette.grey2};
  cursor: pointer;
`

const ShortText = styled(P2)`
  color: ${props => props.theme.palette.grey3};
`

ReadMore.defaultProps = {
  lines: 3,
  more: 'Read more',
  less: 'Show less',
  id: 'read-more',
  disabled: false,
  handleClick: () => {}
}

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  less: PropTypes.string,
  more: PropTypes.string,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func
}

export default ReadMore
